if (!window.__twoWsOrderPromiseDotsInitialized) {
  window.__twoWsOrderPromiseDotsInitialized = true;

  const validDeliveryStrategies = new Set(['ship_complete', 'ship_ready_then_complete', 'ship_available']);
  const validFulfillmentMethods = new Set(['shipping', 'pickup']);
  const deliveryStrategyLabels = {
    ship_complete: 'Alle artikelen samen leveren',
    ship_ready_then_complete: 'Beschikbare artikelen eerst leveren',
    ship_available: 'Artikelen leveren zodra ze beschikbaar zijn',
  };
  const fulfillmentMethodLabels = {
    shipping: 'Verzenden',
    pickup: 'Afhalen',
  };
  const deliverySequenceLabels = [
    'Eerste levering',
    'Tweede levering',
    'Derde levering',
    'Vierde levering',
    'Vijfde levering',
    'Zesde levering',
    'Zevende levering',
    'Achtste levering',
    'Negende levering',
    'Tiende levering',
  ];
  const pickupSequenceLabels = [
    'Eerste afhaalmoment',
    'Tweede afhaalmoment',
    'Derde afhaalmoment',
    'Vierde afhaalmoment',
    'Vijfde afhaalmoment',
    'Zesde afhaalmoment',
    'Zevende afhaalmoment',
    'Achtste afhaalmoment',
    'Negende afhaalmoment',
    'Tiende afhaalmoment',
  ];

  const syncVariantPromiseInputs = ({ data } = {}) => {
    const sectionId = data?.sectionId;
    const html = data?.html;
    if (!sectionId || !html) return;

    const formId = `product-form-${sectionId}`;
    const sourceForm = html.getElementById(formId);
    const destinationForm = document.getElementById(formId);
    if (!sourceForm || !destinationForm) return;

    const selector = 'input[type="hidden"][name^="properties[_2ws_"], [data-two-ws-order-quantity-guard]';
    destinationForm.querySelectorAll(selector).forEach((input) => input.remove());
    const anchor = destinationForm.querySelector('input[name="product-id"]');
    sourceForm.querySelectorAll(selector).forEach((input) => {
      destinationForm.insertBefore(input.cloneNode(true), anchor);
    });
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, syncVariantPromiseInputs);
  }

  const positiveInteger = (value, fallback = 0) => {
    const number = Number.parseInt(value, 10);
    return Number.isFinite(number) && number >= 0 ? number : fallback;
  };

  const formQuantityGuard = (form) => form?.querySelector?.('[data-two-ws-order-quantity-guard]') || null;

  const formQuantityInput = (form) => {
    const input = form?.elements?.namedItem?.('quantity');
    return input instanceof HTMLInputElement ? input : null;
  };

  const quantityGuardLimit = (guard) => {
    if (!guard || guard.dataset.inventoryManagedByShopify !== 'true') return null;
    if (guard.dataset.supplierDirectAvailable === 'true') return null;
    const ownStock = positiveInteger(guard.dataset.ownStock, 0);
    return ownStock > 0 ? ownStock : null;
  };

  const productQuantityError = (form, ownStock) => {
    const wrapper = form.closest?.('product-form')?.querySelector('.product-form__error-message-wrapper');
    const message = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !message) return;
    message.textContent = `Niet voldoende voorraad. Er ${ownStock === 1 ? 'is' : 'zijn'} maximaal ${ownStock} ${ownStock === 1 ? 'stuk' : 'stuks'} beschikbaar.`;
    wrapper.hidden = false;
  };

  const clearProductQuantityError = (form) => {
    const wrapper = form?.closest?.('product-form')?.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.hidden = true;
    const input = formQuantityInput(form);
    input?.removeAttribute('aria-invalid');
  };

  const blockProductQuantityAboveConfirmedStock = (event) => {
    const form = event.target?.closest?.('form');
    const guard = formQuantityGuard(form);
    const ownStock = quantityGuardLimit(guard);
    if (ownStock === null) return false;

    const input = formQuantityInput(form);
    const requested = Math.max(1, positiveInteger(input?.value, 1));
    const alreadyInCart = positiveInteger(input?.dataset?.cartQuantity, 0);
    if (alreadyInCart + requested <= ownStock) {
      clearProductQuantityError(form);
      return false;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (input) input.setAttribute('aria-invalid', 'true');
    productQuantityError(form, ownStock);
    input?.focus({ preventScroll: true });
    return true;
  };

  const attemptedCartPromiseUpdates = new Set();
  let cartPromiseSyncInFlight = false;

  const promiseDateWithWeekday = (promise) => {
    if (promise.prefix === 'rond') return promise.dateNl;
    const date = new Date(`${promise.date}T12:00:00`);
    const weekday = new Intl.DateTimeFormat('nl-NL', { weekday: 'long' }).format(date);
    return `${weekday} ${promise.dateNl}`;
  };

  const latestCartPromiseRecord = (records) => records.reduce((currentLatest, record) => {
    if (!currentLatest || record.current.date > currentLatest.current.date) return record;
    if (record.current.date === currentLatest.current.date && record.current.prefix === 'rond') return record;
    return currentLatest;
  }, null);

  const effectiveCartPromiseRecord = (record) => {
    const ownStock = positiveInteger(record?.current?.ownStockAvailable, 0);
    const quantity = positiveInteger(record?.quantity, 0);
    const usesSupplierStock = quantity > ownStock
      && record?.current?.supplierDirectAvailable === true
      && Boolean(record?.supplier?.date);
    if (!usesSupplierStock) return record;
    return {
      ...record,
      current: {
        ...record.current,
        ...record.supplier,
        ownStockAvailable: ownStock,
        b2bDirectAvailable: record.current.b2bDirectAvailable === true,
        specializedDirectAvailable: record.current.specializedDirectAvailable === true,
        supplierDirectAvailable: true,
        inventoryManagedByShopify: record.current.inventoryManagedByShopify === true,
      },
    };
  };

  const getCartPromiseRecords = () => {
    const records = new Map();
    document.querySelectorAll('script[data-cart-order-promise]').forEach((node) => {
      if (node.closest('.cart-item--small-order-fee')) return;
      try {
        const record = JSON.parse(node.textContent);
        const lineMatch = node.closest('tr.cart-item')?.id?.match(/-(\d+)$/);
        if (record && lineMatch) record.cartLineIndex = Number(lineMatch[1]);
        if (record?.lineKey && record?.current?.date) {
          records.set(record.lineKey, effectiveCartPromiseRecord(record));
        }
      } catch (error) {
        console.warn('2WS kon een winkelwagenbelofte niet lezen.', error);
      }
    });
    return [...records.values()];
  };

  const guardedCartRecord = (input) => {
    const row = input?.closest?.('tr.cart-item');
    const node = row?.querySelector?.('script[data-cart-order-promise]');
    if (!node) return null;
    try {
      const record = JSON.parse(node.textContent);
      const ownStock = positiveInteger(record?.current?.ownStockAvailable, 0);
      if (record?.current?.inventoryManagedByShopify !== true) return null;
      if (record?.current?.supplierDirectAvailable === true) return null;
      if (ownStock <= 0) return null;
      return { record, ownStock, row };
    } catch (error) {
      console.warn('2WS kon de voorraadgrens van een winkelwagenregel niet lezen.', error);
      return null;
    }
  };

  const cartVariantQuantity = (record, records) => {
    const fromMarkup = document.querySelector(
      `.quantity__input[data-quantity-variant-id="${CSS.escape(String(record.variantId || ''))}"]`,
    )?.dataset?.cartQuantity;
    if (fromMarkup !== undefined) return positiveInteger(fromMarkup, 0);
    return records
      .filter((candidate) => String(candidate.variantId) === String(record.variantId))
      .reduce((total, candidate) => total + positiveInteger(candidate.quantity, 0), 0);
  };

  const rememberOriginalCartMaximum = (input) => {
    if (input.dataset.twoWsOriginalMaximumStored === 'true') return;
    input.dataset.twoWsOriginalMaximumStored = 'true';
    input.dataset.twoWsOriginalMax = input.getAttribute('max') || '';
    input.dataset.twoWsOriginalDataMax = input.dataset.max || '';
  };

  const applyCartMaximum = (input, stockMaximum) => {
    rememberOriginalCartMaximum(input);
    const configuredMax = positiveInteger(input.dataset.twoWsOriginalMax, Number.MAX_SAFE_INTEGER);
    const effectiveMax = Math.min(stockMaximum, configuredMax);
    input.max = String(effectiveMax);
    input.dataset.max = String(effectiveMax);
    input.dataset.twoWsConfirmedStockMax = String(effectiveMax);
  };

  const syncCartQuantityLimits = (records = getCartPromiseRecords()) => {
    records.forEach((record) => {
      if (record?.current?.inventoryManagedByShopify !== true) return;
      if (record?.current?.supplierDirectAvailable === true) return;
      const ownStock = positiveInteger(record?.current?.ownStockAvailable, 0);
      if (ownStock <= 0) return;
      const totalForVariant = cartVariantQuantity(record, records);
      const lineQuantity = positiveInteger(record.quantity, 0);
      const maximumForLine = Math.max(0, ownStock - (totalForVariant - lineQuantity));
      [
        document.getElementById(`CartItem-${record.cartLineIndex}`),
        document.getElementById(`CartDrawer-Item-${record.cartLineIndex}`),
      ].filter(Boolean).forEach((row) => {
        const input = row.querySelector('.quantity__input[data-quantity-variant-id]');
        if (input) applyCartMaximum(input, maximumForLine);
      });
    });
  };

  const showCartQuantityError = (row, ownStock) => {
    const error = row?.querySelector('.cart-item__error');
    const message = error?.querySelector('.cart-item__error-text');
    if (!error || !message) return;
    message.textContent = `Niet voldoende voorraad. Er ${ownStock === 1 ? 'is' : 'zijn'} maximaal ${ownStock} ${ownStock === 1 ? 'stuk' : 'stuks'} beschikbaar.`;
    error.classList.add('cart-item__error--active');
  };

  const blockCartQuantityAboveConfirmedStock = (event) => {
    const input = event.target?.closest?.('.cart-item .quantity__input[data-quantity-variant-id]');
    const guarded = guardedCartRecord(input);
    if (!input || !guarded) return false;

    const currentLineQuantity = positiveInteger(guarded.record.quantity, 0);
    const currentVariantQuantity = positiveInteger(input.dataset.cartQuantity, currentLineQuantity);
    const requestedLineQuantity = positiveInteger(input.value, currentLineQuantity);
    const requestedVariantQuantity = currentVariantQuantity - currentLineQuantity + requestedLineQuantity;
    if (requestedVariantQuantity <= guarded.ownStock) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = String(currentLineQuantity);
    showCartQuantityError(guarded.row, guarded.ownStock);
    input.focus({ preventScroll: true });
    return true;
  };

  const getDeliveryControllers = () => [...document.querySelectorAll('[data-cart-delivery-controller]')];
  const mobileBadgeMedia = window.matchMedia('(max-width: 749px)');
  let deliveryCheckoutBlocked = false;
  let pickupCheckoutBusy = false;
  let smallOrderFeeBusy = false;
  let smallOrderFeeReady = false;
  let smallOrderFeePromise = null;
  let smallOrderFeeTimer = null;

  const getFulfillmentState = () => {
    const controllers = getDeliveryControllers();
    const forced = controllers.some((controller) => controller.dataset.cartPickupForced === 'true');
    const checked = document.querySelector('[data-cart-fulfillment-choice] input[value]:checked')?.value || '';
    const stored = controllers.map((controller) => controller.dataset.cartFulfillmentMethod)
      .find((method) => validFulfillmentMethods.has(method)) || '';
    const method = forced
      ? 'pickup'
      : validFulfillmentMethods.has(checked)
        ? checked
        : validFulfillmentMethods.has(stored)
          ? stored
          : 'shipping';
    return { controllers, forced, method };
  };

  const syncFulfillmentUi = (requestedMethod) => {
    const state = getFulfillmentState();
    const method = state.forced ? 'pickup' : validFulfillmentMethods.has(requestedMethod) ? requestedMethod : state.method;
    state.controllers.forEach((controller) => {
      controller.dataset.cartFulfillmentMethod = method;
      controller.dataset.cartPromiseLabel = method === 'pickup' ? 'Afhaaldatum:' : 'Verzenddatum:';
      controller.dataset.cartShippingSummaryEnabled = method === 'shipping' ? 'true' : 'false';
      controller.querySelectorAll('.cart-fulfillment-option__input').forEach((input) => {
        input.checked = input.value === method;
      });
      controller.querySelectorAll('[data-cart-shipping-options]').forEach((panel) => {
        panel.hidden = method !== 'shipping';
      });
      controller.querySelectorAll('[data-cart-pickup-options]').forEach((panel) => {
        panel.hidden = method !== 'pickup';
      });
      controller.querySelectorAll('[data-cart-shipping-promise-text] > strong').forEach((label) => {
        label.textContent = controller.dataset.cartPromiseLabel;
      });
    });
    return method;
  };

  const elementIsVisible = (element) => {
    if (!element?.isConnected) return false;
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return element.getClientRects().length > 0;
  };

  const checkoutTermsScope = (element) => {
    const drawer = element?.closest?.('cart-drawer');
    if (drawer) return drawer;
    return element?.closest?.('#main-cart-footer') || document;
  };

  const visibleTermsCheckbox = (element) => {
    const scope = checkoutTermsScope(element);
    const scoped = [...scope.querySelectorAll('.rale-widget input[type="checkbox"]')]
      .find((checkbox) => !checkbox.disabled && elementIsVisible(checkbox));
    if (scoped) return scoped;
    if (scope !== document) return null;
    return [...document.querySelectorAll('.rale-widget input[type="checkbox"]')]
      .find((checkbox) => (
        !checkbox.disabled
        && elementIsVisible(checkbox)
        && !checkbox.closest('cart-drawer, cart-notification')
      )) || null;
  };

  const termsAreAccepted = (element) => Boolean(visibleTermsCheckbox(element)?.checked);

  const termsErrorFor = (element, create = false) => {
    const checkbox = visibleTermsCheckbox(element);
    const widget = checkbox?.closest('.rale-widget');
    if (!widget) return null;
    let error = widget.parentElement?.querySelector(':scope > [data-two-ws-terms-error]');
    if (!error && create) {
      error = document.createElement('p');
      error.className = 'cart-errors cart-terms-error';
      error.dataset.twoWsTermsError = '';
      error.hidden = true;
      error.textContent = 'Vink hierboven eerst aan dat je akkoord gaat met de algemene voorwaarden en het privacybeleid.';
      widget.insertAdjacentElement('afterend', error);
    }
    return error;
  };

  const showTermsError = (element) => {
    const checkbox = visibleTermsCheckbox(element);
    const error = termsErrorFor(element, true);
    if (error) error.hidden = false;
    checkbox?.closest('.rale-widget')?.classList.add('two-ws-terms-attention');
    checkbox?.focus({ preventScroll: true });
    checkbox?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const smallOrderFeeConfig = () => {
    const script = document.querySelector('script[data-small-order-fee-config]');
    if (!script) return null;
    try {
      const config = JSON.parse(script.textContent || '{}');
      const belowTenVariantId = Number(config.belowTenVariantId);
      const belowTwentyVariantId = Number(config.belowTwentyVariantId);
      if (!config.handle || !belowTenVariantId || !belowTwentyVariantId) return null;
      const valveSets = Array.isArray(config.valveSets) ? config.valveSets.map((entry) => ({
        sourceVariantId: Number(entry.sourceVariantId),
        bundleVariantId: Number(entry.bundleVariantId),
      })).filter((entry) => entry.sourceVariantId > 0 && entry.bundleVariantId > 0) : [];
      return {
        handle: String(config.handle),
        belowTenVariantId,
        belowTwentyVariantId,
        belowTenThresholdCents: Number(config.belowTenThresholdCents) || 1_000,
        belowTwentyThresholdCents: Number(config.belowTwentyThresholdCents) || 2_000,
        valveSets,
      };
    } catch (error) {
      console.warn('2WS kon de configuratie voor de kleine-bestellingstoeslag niet lezen.', error);
      return null;
    }
  };

  const cartSectionRequest = () => {
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    const mainItems = document.getElementById('main-cart-items')?.dataset.id;
    const mainFooter = document.getElementById('main-cart-footer')?.dataset.id;
    if (mainItems) sections.push(mainItems);
    if (mainFooter) sections.push(mainFooter);
    return [...new Set(sections)];
  };

  const sectionDocument = (html) => new DOMParser().parseFromString(html || '', 'text/html');

  const replaceSectionContents = (target, source) => {
    if (!target || !source) return;
    target.innerHTML = source.innerHTML;
  };

  const renderSmallOrderFeeSections = (state, requestedSections) => {
    const sections = state?.sections || {};
    const drawerHtml = sections['cart-drawer'];
    if (drawerHtml) {
      const source = sectionDocument(drawerHtml);
      const currentItems = document.querySelector('cart-drawer-items');
      const sourceItems = source.querySelector('cart-drawer-items');
      if (currentItems && sourceItems) currentItems.replaceWith(sourceItems);
      const currentFooter = document.querySelector('cart-drawer .cart-drawer__footer');
      const sourceFooter = source.querySelector('.cart-drawer__footer');
      if (currentFooter && sourceFooter) currentFooter.replaceWith(sourceFooter);
    }

    const bubbleHtml = sections['cart-icon-bubble'];
    if (bubbleHtml) {
      const source = sectionDocument(bubbleHtml).querySelector('.shopify-section');
      replaceSectionContents(document.getElementById('cart-icon-bubble'), source);
    }

    const mainItemsId = document.getElementById('main-cart-items')?.dataset.id;
    if (mainItemsId && sections[mainItemsId]) {
      const source = sectionDocument(sections[mainItemsId]).querySelector('.js-contents');
      replaceSectionContents(document.querySelector('#main-cart-items .js-contents'), source);
    }

    const mainFooterId = document.getElementById('main-cart-footer')?.dataset.id;
    if (mainFooterId && sections[mainFooterId]) {
      const source = sectionDocument(sections[mainFooterId]).querySelector('.js-contents');
      replaceSectionContents(document.querySelector('#main-cart-footer .js-contents'), source);
    }

    const hasVisibleItems = (state?.items || []).some((item) => item.handle !== 'toeslag-kleine-bestelling');
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', !hasVisibleItems);
    document.querySelector('cart-items')?.classList.toggle('is-empty', !hasVisibleItems);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', !hasVisibleItems);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'small-order-fee',
        cartData: state,
        requestedSections,
      });
    }
  };

  const smallOrderProductSubtotal = (cart, feeHandle) => (cart.items || [])
    .filter((item) => item.handle !== feeHandle)
    .reduce((total, item) => total + Number(item.final_line_price ?? item.line_price ?? 0), 0);

  const targetSmallOrderFeeVariant = (cart, config) => {
    const regularItems = (cart.items || []).filter((item) => item.handle !== config.handle);
    if (!regularItems.length) return null;
    const subtotal = smallOrderProductSubtotal(cart, config.handle);
    if (subtotal < config.belowTenThresholdCents) return config.belowTenVariantId;
    if (subtotal < config.belowTwentyThresholdCents) return config.belowTwentyVariantId;
    return null;
  };

  const smallOrderFeeUpdates = (cart, config) => {
    const targetVariantId = targetSmallOrderFeeVariant(cart, config);
    const feeItems = (cart.items || []).filter((item) => item.handle === config.handle);
    const targetItems = feeItems.filter((item) => Number(item.variant_id) === targetVariantId);
    const valid = targetVariantId === null
      ? feeItems.length === 0
      : feeItems.length === 1 && targetItems.length === 1 && Number(targetItems[0].quantity) === 1;
    if (valid) return null;

    const updates = {};
    feeItems.forEach((item) => { updates[item.key] = 0; });
    if (targetVariantId !== null) {
      const existingTarget = targetItems[0];
      if (existingTarget) updates[existingTarget.key] = 1;
      else updates[String(targetVariantId)] = 1;
    }
    return updates;
  };

  const valveSetUpdates = (cart, config) => {
    const updates = {};
    let changed = false;
    for (const mapping of config.valveSets || []) {
      const sourceItems = (cart.items || []).filter((item) => Number(item.variant_id) === mapping.sourceVariantId);
      const bundleItems = (cart.items || []).filter((item) => Number(item.variant_id) === mapping.bundleVariantId);
      const totalPieces = sourceItems.reduce((total, item) => total + Number(item.quantity || 0), 0)
        + bundleItems.reduce((total, item) => total + (Number(item.quantity || 0) * 2), 0);
      const targetBundleQuantity = Math.floor(totalPieces / 2);
      const targetSourceQuantity = totalPieces % 2;
      const sourceIsCorrect = targetSourceQuantity === 0
        ? sourceItems.length === 0
        : sourceItems.length === 1 && Number(sourceItems[0].quantity) === targetSourceQuantity;
      const bundleIsCorrect = targetBundleQuantity === 0
        ? bundleItems.length === 0
        : bundleItems.length === 1 && Number(bundleItems[0].quantity) === targetBundleQuantity;
      if (sourceIsCorrect && bundleIsCorrect) continue;

      changed = true;
      [...sourceItems, ...bundleItems].forEach((item) => { updates[item.key] = 0; });
      if (targetSourceQuantity > 0) {
        updates[sourceItems[0]?.key || String(mapping.sourceVariantId)] = targetSourceQuantity;
      }
      if (targetBundleQuantity > 0) {
        updates[bundleItems[0]?.key || String(mapping.bundleVariantId)] = targetBundleQuantity;
      }
    }
    return changed ? updates : null;
  };

  const updateCart = async (root, updates, requestedSections, errorLabel) => {
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates,
        sections: requestedSections,
        sections_url: window.location.pathname,
      }),
    });
    if (!response.ok) throw new Error(`${errorLabel} gaf ${response.status}.`);
    return response.json();
  };

  const syncSmallOrderFee = async () => {
    if (smallOrderFeePromise) return smallOrderFeePromise;
    const config = smallOrderFeeConfig();
    if (!config) {
      smallOrderFeeReady = true;
      syncCheckoutAvailability();
      return false;
    }

    smallOrderFeeBusy = true;
    smallOrderFeeReady = false;
    syncCheckoutAvailability();
    smallOrderFeePromise = (async () => {
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(`Winkelwagen ophalen gaf ${cartResponse.status}.`);
      const requestedSections = cartSectionRequest();
      let cart = await cartResponse.json();
      let changed = false;

      const valveUpdates = valveSetUpdates(cart, config);
      if (valveUpdates) {
        cart = await updateCart(root, valveUpdates, requestedSections, 'Ventielsets bijwerken');
        changed = true;
      }

      const feeUpdates = smallOrderFeeUpdates(cart, config);
      if (feeUpdates) {
        cart = await updateCart(root, feeUpdates, requestedSections, 'Toeslag bijwerken');
        changed = true;
      }

      if (changed) renderSmallOrderFeeSections(cart, requestedSections);
      return changed;
    })();

    let succeeded = false;
    try {
      const changed = await smallOrderFeePromise;
      succeeded = true;
      return changed;
    } catch (error) {
      console.warn('2WS kon de winkelwagenregels niet synchroniseren.', error);
      const message = 'De winkelwagen kon niet volledig worden bijgewerkt. Vernieuw de winkelwagen en probeer het opnieuw.';
      const errorTargets = [document.getElementById('cart-errors'), document.getElementById('CartDrawer-CartErrors')];
      errorTargets.forEach((target) => { if (target) target.textContent = message; });
      return false;
    } finally {
      smallOrderFeePromise = null;
      smallOrderFeeBusy = false;
      smallOrderFeeReady = succeeded;
      syncCheckoutAvailability();
    }
  };

  const scheduleSmallOrderFeeSync = () => {
    smallOrderFeeReady = false;
    syncCheckoutAvailability();
    window.clearTimeout(smallOrderFeeTimer);
    smallOrderFeeTimer = window.setTimeout(() => void syncSmallOrderFee(), 0);
  };

  const syncCheckoutAvailability = () => {
    document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach((button) => {
      const termsMissing = !termsAreAccepted(button) || window.twoWsBikeOrderConsent?.accepted(button) === false;
      const feePending = smallOrderFeeBusy || !smallOrderFeeReady;
      button.setAttribute('aria-disabled', deliveryCheckoutBlocked || feePending || termsMissing ? 'true' : 'false');
      button.dataset.twoWsTermsBlocked = termsMissing ? 'true' : 'false';
      if (deliveryCheckoutBlocked && !button.disabled) {
        button.disabled = true;
        button.dataset.twoWsCheckoutDisabled = 'true';
      } else if (!deliveryCheckoutBlocked && button.dataset.twoWsCheckoutDisabled === 'true') {
        button.disabled = false;
        delete button.dataset.twoWsCheckoutDisabled;
      }
      if (feePending && !button.disabled) {
        button.disabled = true;
        button.dataset.twoWsFeeDisabled = 'true';
      } else if (!feePending && button.dataset.twoWsFeeDisabled === 'true') {
        button.disabled = false;
        delete button.dataset.twoWsFeeDisabled;
      }
      const error = termsErrorFor(button);
      if (!termsMissing) {
        if (error) error.hidden = true;
        visibleTermsCheckbox(button)?.closest('.rale-widget')?.classList.remove('two-ws-terms-attention');
      }
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach((buttons) => {
      const shouldHide = deliveryCheckoutBlocked
        || pickupCheckoutBusy
        || smallOrderFeeBusy
        || !smallOrderFeeReady
        || getFulfillmentState().method === 'pickup'
        || !termsAreAccepted(buttons);
      buttons.hidden = shouldHide;
      buttons.toggleAttribute('aria-hidden', shouldHide);
      buttons.dataset.twoWsCheckoutHidden = shouldHide ? 'true' : 'false';
    });
  };

  const checkoutTarget = (eventTarget) => eventTarget?.closest?.(
    '#checkout, #CartDrawer-Checkout, .additional-checkout-buttons',
  );

  const blockCheckoutWithoutTerms = (event) => {
    const target = checkoutTarget(event.target);
    if (!target || termsAreAccepted(target)) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    showTermsError(target);
    syncCheckoutAvailability();
    return true;
  };

  const setupBadgeToggles = () => {
    document.querySelectorAll('.cart-delivery-option__badges').forEach((group) => {
      const badges = [...group.querySelectorAll('[data-cart-delivery-badge]')];
      const interactive = badges.length > 1 && mobileBadgeMedia.matches;
      group.classList.toggle('cart-delivery-option__badges--interactive', interactive);
      if (!interactive) {
        delete group.dataset.expandedBadge;
        badges.forEach((badge) => {
          badge.classList.remove('cart-delivery-option__badge--collapsed');
          badge.removeAttribute('role');
          badge.removeAttribute('tabindex');
          badge.removeAttribute('aria-expanded');
          badge.removeAttribute('aria-label');
        });
        return;
      }

      const availableKinds = badges.map((badge) => badge.dataset.cartDeliveryBadge);
      const expanded = availableKinds.includes(group.dataset.expandedBadge)
        ? group.dataset.expandedBadge
        : availableKinds.includes('recommended')
          ? 'recommended'
          : availableKinds[0];
      group.dataset.expandedBadge = expanded;
      badges.forEach((badge) => {
        const kind = badge.dataset.cartDeliveryBadge;
        const isExpanded = kind === expanded;
        const label = badge.querySelector(':scope > span:last-child')?.textContent?.trim() || 'Optielabel';
        badge.classList.toggle('cart-delivery-option__badge--collapsed', !isExpanded);
        badge.setAttribute('role', 'button');
        badge.setAttribute('tabindex', '0');
        badge.setAttribute('aria-label', label);
        badge.setAttribute('aria-expanded', String(isExpanded));
      });
    });
  };

  const activateBadgeToggle = (event) => {
    const badge = event.target.closest?.('.cart-delivery-option__badge');
    const group = badge?.closest('.cart-delivery-option__badges--interactive');
    if (!badge || !group || !mobileBadgeMedia.matches) return false;
    event.preventDefault();
    event.stopPropagation();
    group.dataset.expandedBadge = badge.dataset.cartDeliveryBadge;
    setupBadgeToggles();
    return true;
  };

  const getDeliveryState = () => {
    const controllers = getDeliveryControllers();
    const choiceEnabled = controllers.some((controller) => controller.querySelector('[data-cart-delivery-choice]'));
    const mixed = choiceEnabled && controllers.some((controller) => controller.dataset.cartIsMixed === 'true');
    const checked = document.querySelector('[data-cart-delivery-choice] input[value]:checked')?.value || '';
    const stored = controllers.map((controller) => controller.dataset.cartDeliveryStrategy)
      .find((strategy) => validDeliveryStrategies.has(strategy)) || '';
    const strategy = validDeliveryStrategies.has(checked) ? checked : stored;
    const fulfillmentMethod = getFulfillmentState().method;
    return { controllers, mixed, fulfillmentMethod, strategy: mixed ? strategy : 'ship_complete' };
  };

  const sortDeliveryShipmentRows = () => {
    document.querySelectorAll('.cart-delivery-option__shipments').forEach((list) => {
      const rows = [...list.querySelectorAll(':scope > [data-cart-delivery-shipment]')];
      const pickupSequence = list.dataset.shipmentSequence === 'pickup';
      rows.sort((left, right) => {
        const leftDate = left.dataset.shipmentDate || '9999-12-31';
        const rightDate = right.dataset.shipmentDate || '9999-12-31';
        return leftDate.localeCompare(rightDate);
      });
      rows.forEach((row, index) => {
        list.append(row);
        const title = row.querySelector('[data-cart-delivery-shipment-title]');
        const sequence = row.querySelector('[data-cart-delivery-shipment-sequence]');
        const sequenceLabel = pickupSequence
          ? rows.length === 1
            ? 'Eén afhaalmoment'
            : pickupSequenceLabels[index] || `Afhaalmoment ${index + 1}`
          : rows.length === 1
            ? 'Eén levering'
            : deliverySequenceLabels[index] || `Levering ${index + 1}`;
        if (sequence) sequence.textContent = sequenceLabel;
        else if (title) title.textContent = sequenceLabel;
      });
    });
  };

  const recordShipmentKind = (record) => record.current?.properties?._2ws_promise_profile === 'frameset'
    ? 'Frameset'
    : 'Onderdelen';

  const recordFitsShipment = (record, shipment) => {
    const mode = shipment.dataset.shipmentMode || 'complete';
    const date = shipment.dataset.shipmentDate || '';
    const route = record.current?.properties?._2ws_promise_route || '';
    if (mode !== 'pickup_date' && recordShipmentKind(record) !== (shipment.dataset.shipmentKind || 'Onderdelen')) return false;
    if (mode === 'ready') return route !== 'supplier_future';
    if (mode === 'future_complete') return route === 'supplier_future';
    if (mode === 'future_date') return route === 'supplier_future' && record.current?.date === date;
    if (mode === 'pickup_date') return record.current?.date === date;
    return true;
  };

  const renderShipmentContents = (records) => {
    document.querySelectorAll('[data-cart-delivery-shipment]').forEach((shipment) => {
      shipment.querySelector('[data-cart-shipment-products]')?.remove();
      const matching = records.filter((record) => recordFitsShipment(record, shipment));
      if (!matching.length) return;
      const products = document.createElement('span');
      products.className = 'cart-delivery-shipment__products';
      products.dataset.cartShipmentProducts = '';
      matching.forEach((record) => {
        const item = document.createElement('span');
        item.className = 'cart-delivery-shipment__product';
        const quantity = Math.max(1, Number(record.quantity) || 1);
        const variant = record.variantTitle ? ` – ${record.variantTitle}` : '';
        item.textContent = `${quantity} × ${record.productTitle || 'Artikel'}${variant}`;
        products.append(item);
      });
      shipment.querySelector('.cart-delivery-shipment__copy')?.append(products);
    });
  };

  const updateCartOrderSummary = (strategy, fulfillmentMethod = getFulfillmentState().method) => {
    const summary = document.querySelector('[data-cart-order-summary]');
    if (!summary) return;

    const controller = document.querySelector('#main-cart-footer [data-cart-delivery-controller]');
    const pickupActive = fulfillmentMethod === 'pickup';
    const hasCalculatedShipping = pickupActive || (
      controller?.dataset.cartShippingSummaryEnabled === 'true'
      && validDeliveryStrategies.has(strategy)
    );
    const productsRow = summary.querySelector('[data-cart-summary-products]');
    const shippingRow = summary.querySelector('[data-cart-summary-shipping]');
    const shippingLabel = summary.querySelector('[data-cart-summary-shipping-label]');
    const shippingValue = summary.querySelector('[data-cart-summary-shipping-value]');
    const totalLabel = summary.querySelector('[data-cart-summary-total-label]');
    const totalValue = summary.querySelector('[data-cart-summary-total-value]');
    const defaultTaxNote = document.querySelector('[data-cart-default-tax-note]');
    const shippingIncludedNote = document.querySelector('[data-cart-shipping-included-note]');
    const setText = (element, value) => {
      if (element && element.textContent !== value) element.textContent = value;
    };

    const hasSmallOrderFee = summary.dataset.hasSmallOrderFee === 'true';
    if (productsRow) productsRow.hidden = !hasCalculatedShipping && !hasSmallOrderFee;
    if (shippingRow) shippingRow.hidden = !hasCalculatedShipping;
    if (defaultTaxNote) defaultTaxNote.hidden = hasCalculatedShipping;
    if (shippingIncludedNote) shippingIncludedNote.hidden = !hasCalculatedShipping;

    if (!hasCalculatedShipping) {
      setText(shippingLabel, 'Verzendkosten');
      setText(totalLabel, 'Geschat totaal');
      setText(totalValue, summary.dataset.cartTotalFormatted || summary.dataset.productsTotalFormatted || '');
      return;
    }

    if (pickupActive) {
      setText(shippingLabel, 'Afhalen');
      setText(shippingValue, 'Gratis');
      setText(totalLabel, 'Totaal');
      setText(totalValue, summary.dataset.cartTotalFormatted || summary.dataset.productsTotalFormatted || '');
      return;
    }

    const isAvailable = strategy === 'ship_available';
    const isReadyThenComplete = strategy === 'ship_ready_then_complete';
    setText(shippingLabel, 'Verzendkosten');
    setText(shippingValue, isAvailable
      ? controller.dataset.cartAvailableShippingFormatted
      : isReadyThenComplete
        ? controller.dataset.cartReadyThenCompleteShippingFormatted
        : controller.dataset.cartCompleteShippingFormatted);
    setText(totalLabel, 'Totaal');
    setText(totalValue, isAvailable
      ? controller.dataset.cartAvailableOrderTotalFormatted
      : isReadyThenComplete
        ? controller.dataset.cartReadyThenCompleteOrderTotalFormatted
        : controller.dataset.cartCompleteOrderTotalFormatted);
  };

  const setDeliveryControlsState = ({ strategy, busy = false, error = '' }) => {
    const { controllers, mixed, fulfillmentMethod } = getDeliveryState();
    syncFulfillmentUi(fulfillmentMethod);
    sortDeliveryShipmentRows();
    setupBadgeToggles();
    controllers.forEach((controller) => {
      if (validDeliveryStrategies.has(strategy)) controller.dataset.cartDeliveryStrategy = strategy;
      controller.querySelectorAll('[data-cart-delivery-choice]').forEach((choice) => {
        choice.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
      controller.querySelectorAll('.cart-delivery-option__input').forEach((input) => {
        input.checked = input.value === strategy;
      });
      controller.querySelectorAll('[data-cart-delivery-choice-status]').forEach((status) => {
        status.classList.toggle('cart-delivery-choice__help--selected', Boolean(strategy) && !error);
        if (error) status.textContent = error;
        else if (busy) status.textContent = 'Je keuze wordt opgeslagen…';
        else if (strategy) status.textContent = 'Je keuze is opgeslagen.';
        else status.textContent = 'Kies een verzendoptie om af te rekenen.';
      });
    });
    updateCartOrderSummary(strategy, fulfillmentMethod);

    const choiceMissing = fulfillmentMethod === 'shipping' && mixed && !validDeliveryStrategies.has(strategy);
    deliveryCheckoutBlocked = choiceMissing || busy || pickupCheckoutBusy;
    syncCheckoutAvailability();
  };

  const renderCurrentCartPromise = (records) => {
    const latestRecord = latestCartPromiseRecord(records);
    if (!latestRecord) return;
    records.forEach((record) => {
      [
        document.getElementById(`CartItem-${record.cartLineIndex}`),
        document.getElementById(`CartDrawer-Item-${record.cartLineIndex}`),
      ].filter(Boolean).forEach((row) => {
        const status = row.querySelector('.cart-stock-status');
        const text = status?.querySelector('.cart-stock-status__text');
        const dot = status?.querySelector('.order-promise-dot');
        if (text && record.current.status) text.textContent = record.current.status;
        if (dot && ['green', 'lime', 'yellow', 'orange'].includes(record.current.dot)) {
          dot.className = `order-promise-dot order-promise-dot--${record.current.dot}`;
        }
      });
    });
    renderShipmentContents(records);
    sortDeliveryShipmentRows();
    const latest = latestRecord.current;

    document.querySelectorAll('[data-cart-shipping-promise]').forEach((element) => {
      element.hidden = false;
      const dot = element.querySelector('[data-cart-shipping-promise-dot]');
      const dotColor = ['green', 'lime', 'yellow', 'orange'].includes(latest.dot) ? latest.dot : 'green';
      if (dot) dot.className = `order-promise-dot order-promise-dot--${dotColor}`;
      const text = element.querySelector('[data-cart-shipping-promise-text]');
      if (!text) return;
      text.textContent = '';
      const label = document.createElement('strong');
      label.textContent = element.closest('[data-cart-delivery-controller]')?.dataset.cartPromiseLabel || 'Verzenddatum:';
      text.append(label, ` ${latest.prefix || 'uiterlijk'} ${promiseDateWithWeekday(latest)}.`);
    });
  };

  const recordRoute = (record) => record.current?.properties?._2ws_promise_route || '';

  const strategyCarrierRecord = (records) => records.find((record) =>
    String(record.stored?.properties?._2ws_shipping_controller ?? '') === 'true'
  ) || records[0] || null;

  const isCorruptedNumericProperty = ([key, value]) => {
    if (!/^\d+$/.test(String(key))) return false;
    if (Array.isArray(value)) return true;
    return /^\d*(?:_2ws_|Verzenddatum|Afhaaldatum)/.test(String(value ?? ''));
  };

  const normalizeStoredLineProperties = (properties) => {
    const entries = Array.isArray(properties)
      ? properties
      : properties && typeof properties === 'object'
        ? Object.entries(properties)
        : [];
    return Object.fromEntries(entries.filter((entry) => !isCorruptedNumericProperty(entry)));
  };

  const desiredPromiseProperties = (record, strategy, isStrategyCarrier = false) => {
    const properties = { ...record.current.properties };
    delete properties._2ws_shipping_group;
    delete properties._2ws_shipping_controller;
    delete properties._2ws_delivery_strategy_label;
    if (isStrategyCarrier) {
      properties._2ws_shipping_group = strategy;
      properties._2ws_shipping_controller = 'true';
      properties._2ws_delivery_strategy_label = deliveryStrategyLabels[strategy] || strategy;
    }
    return properties;
  };

  const cartPromiseNeedsUpdate = (record, strategy, isStrategyCarrier) => {
    const desiredProperties = desiredPromiseProperties(record, strategy, isStrategyCarrier);
    const privatePromiseChanged = Object.entries(desiredProperties)
      .some(([key, value]) => String(record.stored?.properties?.[key] ?? '') !== String(value));
    const customerVisiblePromise = String(record.stored?.properties?.Verzenddatum ?? '')
      || String(record.stored?.properties?.Afhaaldatum ?? '');
    return privatePromiseChanged || customerVisiblePromise !== '';
  };

  const syncCurrentCartPromises = async () => {
    const records = getCartPromiseRecords();
    renderCurrentCartPromise(records);
    if (!records.length || cartPromiseSyncInFlight) return false;

    const { strategy } = getDeliveryState();
    const effectiveStrategy = validDeliveryStrategies.has(strategy) ? strategy : 'ship_complete';
    const carrier = strategyCarrierRecord(records);
    const stale = records.filter((record) => {
      const signature = `${record.lineKey}|${record.current.date}|${record.current.message}|${effectiveStrategy}`;
      if (attemptedCartPromiseUpdates.has(signature)) return false;
      const needsUpdate = cartPromiseNeedsUpdate(
        record,
        effectiveStrategy,
        record.lineKey === carrier?.lineKey,
      );
      if (needsUpdate) attemptedCartPromiseUpdates.add(signature);
      return needsUpdate;
    });
    if (!stale.length) return false;

    cartPromiseSyncInFlight = true;
    const root = window.Shopify?.routes?.root || '/';
    let cartWasUpdated = false;
    try {
      let cart = await fetch(`${root}cart.js`).then((response) => response.json());
      for (const record of stale) {
        const itemIndex = cart.items.findIndex((candidate) => candidate.key === record.lineKey);
        if (itemIndex < 0) continue;
        const item = cart.items[itemIndex];
        const properties = {
          ...normalizeStoredLineProperties(item.properties),
          ...desiredPromiseProperties(record, effectiveStrategy, record.lineKey === carrier?.lineKey),
        };
        delete properties.Verzenddatum;
        delete properties.Afhaaldatum;
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: itemIndex + 1,
            quantity: item.quantity,
            properties,
          }),
        });
        if (!response.ok) throw new Error(`Cart API ${response.status}`);
        cart = await response.json();
        cartWasUpdated = true;
      }
    } catch (error) {
      console.warn('2WS kon verouderde winkelwagenbeloftes niet herstellen.', error);
    } finally {
      cartPromiseSyncInFlight = false;
    }
    if (cartWasUpdated) window.location.reload();
    return cartWasUpdated;
  };

  const persistDeliveryStrategy = async (strategy) => {
    if (!validDeliveryStrategies.has(strategy)) return;
    setDeliveryControlsState({ strategy, busy: true });
    const root = window.Shopify?.routes?.root || '/';
    try {
      const records = getCartPromiseRecords();
      const carrier = strategyCarrierRecord(records);
      const carrierLine = Number(carrier?.cartLineIndex);
      if (!carrier || !Number.isInteger(carrierLine) || carrierLine < 1) {
        throw new Error('Geen regel voor de verzendkeuze gevonden.');
      }

      const properties = {
        ...normalizeStoredLineProperties(carrier.stored?.allProperties || carrier.stored?.properties),
        ...desiredPromiseProperties(carrier, strategy, true),
      };
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: carrierLine,
          quantity: carrier.quantity,
          properties,
        }),
      });
      if (!response.ok) throw new Error(`Cart API ${response.status}`);
      getDeliveryControllers().forEach((controller) => {
        controller.dataset.cartDeliveryStrategy = strategy;
      });
      attemptedCartPromiseUpdates.clear();
      setDeliveryControlsState({ strategy });

      void fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            _2ws_delivery_strategy: strategy,
            _2ws_delivery_strategy_label: deliveryStrategyLabels[strategy],
          },
        }),
      }).then((attributeResponse) => {
        if (!attributeResponse.ok) throw new Error(`Cart attributes ${attributeResponse.status}`);
      }).catch((error) => {
        console.warn('2WS kon het aanvullende orderkenmerk niet opslaan.', error);
      });
    } catch (error) {
      console.warn('2WS kon de leveringskeuze niet opslaan.', error);
      setDeliveryControlsState({ strategy: '', error: 'Opslaan is niet gelukt. Probeer de keuze opnieuw.' });
    }
  };

  const persistFulfillmentMethod = async (requestedMethod) => {
    const state = getFulfillmentState();
    const method = state.forced ? 'pickup' : requestedMethod;
    if (!validFulfillmentMethods.has(method)) return;
    syncFulfillmentUi(method);
    setDeliveryControlsState({ strategy: getDeliveryState().strategy });

    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            _2ws_fulfillment_method: method,
            _2ws_fulfillment_method_label: fulfillmentMethodLabels[method],
          },
        }),
      });
      if (!response.ok) throw new Error(`Cart attributes ${response.status}`);
    } catch (error) {
      console.warn('2WS kon de keuze afhalen/verzenden niet opslaan.', error);
      const fallback = method === 'pickup' ? 'shipping' : 'pickup';
      if (!state.forced) syncFulfillmentUi(fallback);
      setDeliveryControlsState({
        strategy: getDeliveryState().strategy,
        error: 'Opslaan is niet gelukt. Probeer de keuze opnieuw.',
      });
    }
  };

  const storefrontId = (type, value) => {
    const stringValue = String(value || '');
    return stringValue.startsWith('gid://') ? stringValue : `gid://shopify/${type}/${stringValue}`;
  };

  const storefrontAttributes = (properties) => Object.entries(properties || {})
    .filter(([key, value]) => key && value !== null && value !== undefined && String(value) !== '')
    .map(([key, value]) => ({ key: String(key), value: String(value) }));

  const pickupCartLine = (item, promiseRecord) => {
    const properties = normalizeStoredLineProperties(item.properties);
    delete properties.Verzenddatum;
    delete properties.Afhaaldatum;
    const line = {
      merchandiseId: storefrontId('ProductVariant', item.variant_id || item.id),
      quantity: item.quantity,
      attributes: storefrontAttributes(properties),
    };
    const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
    if (sellingPlanId) line.sellingPlanId = storefrontId('SellingPlan', sellingPlanId);
    return line;
  };

  const pickupCheckoutError = (message = '') => {
    const error = document.querySelector('#cart-errors') || document.querySelector('.cart-errors');
    if (!error) return;
    error.textContent = message;
    error.classList.toggle('cart-errors--visible', Boolean(message));
  };

  const createPickupCheckout = async (target) => {
    const root = window.Shopify?.routes?.root || '/';
    const ajaxResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!ajaxResponse.ok) throw new Error(`Cart API ${ajaxResponse.status}`);
    const ajaxCart = await ajaxResponse.json();
    const bikeConsentAttributes = window.twoWsBikeOrderConsent?.attributes(ajaxCart, target) || {};
    const promiseRecords = new Map(getCartPromiseRecords().map((record) => [record.lineKey, record]));
    const lines = ajaxCart.items.map((item) => pickupCartLine(item, promiseRecords.get(item.key)));
    const totalQuantity = lines.reduce((total, line) => total + line.quantity, 0);
    const attributes = {
      ...(ajaxCart.attributes || {}),
      ...bikeConsentAttributes,
      _2ws_fulfillment_method: 'pickup',
      _2ws_fulfillment_method_label: fulfillmentMethodLabels.pickup,
    };
    const discountCodes = (ajaxCart.discount_codes || [])
      .map((discount) => typeof discount === 'string' ? discount : discount?.code)
      .filter(Boolean);
    const input = {
      lines,
      attributes: storefrontAttributes(attributes),
      buyerIdentity: {
        countryCode: String(window.Shopify?.country || 'NL').toUpperCase(),
        preferences: { delivery: { deliveryMethod: ['PICK_UP'] } },
      },
    };
    if (ajaxCart.note) input.note = ajaxCart.note;
    if (discountCodes.length) input.discountCodes = discountCodes;

    const query = `mutation TwoWsPickupCart($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
          totalQuantity
          lines(first: 250) { nodes { id quantity merchandise { ... on ProductVariant { id } } } }
          buyerIdentity { preferences { delivery { deliveryMethod } } }
        }
        userErrors { field message }
        warnings { code message target }
      }
    }`;
    const storefrontResponse = await fetch('/api/2026-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query, variables: { input } }),
    });
    if (!storefrontResponse.ok) throw new Error(`Storefront API ${storefrontResponse.status}`);
    const payload = await storefrontResponse.json();
    const result = payload?.data?.cartCreate;
    const errors = [...(payload?.errors || []), ...(result?.userErrors || [])];
    if (errors.length) throw new Error(errors.map((error) => error.message).join(' '));
    const cart = result?.cart;
    if (!cart?.checkoutUrl) throw new Error('De afhaalcheckout heeft geen checkoutlink teruggegeven.');
    if (cart.totalQuantity !== totalQuantity || cart.lines?.nodes?.length !== lines.length) {
      throw new Error('Niet alle artikelen zijn in de afhaalcheckout overgenomen.');
    }
    if (!cart.buyerIdentity?.preferences?.delivery?.deliveryMethod?.includes('PICK_UP')) {
      throw new Error('De afhaalvoorkeur is niet door Shopify bevestigd.');
    }
    const checkoutUrl = new URL(cart.checkoutUrl);
    if (bikeConsentAttributes._2ws_bike_terms_acknowledged) {
      checkoutUrl.searchParams.set('skip_shop_pay', 'true');
      checkoutUrl.searchParams.set('shop_pay_checkout_as_guest', 'true');
    }
    return checkoutUrl.toString();
  };

  const beginPickupCheckout = async (target) => {
    if (pickupCheckoutBusy) return;
    pickupCheckoutBusy = true;
    pickupCheckoutError('');
    setDeliveryControlsState({ strategy: getDeliveryState().strategy, busy: true });
    document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach((button) => {
      button.setAttribute('aria-busy', 'true');
    });
    try {
      const checkoutUrl = await createPickupCheckout(target);
      window.location.assign(checkoutUrl);
    } catch (error) {
      console.warn('2WS kon de afhaalcheckout niet openen.', error);
      pickupCheckoutBusy = false;
      document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach((button) => {
        button.removeAttribute('aria-busy');
      });
      setDeliveryControlsState({ strategy: getDeliveryState().strategy });
      pickupCheckoutError('Afhalen openen is niet gelukt. Probeer het opnieuw of neem contact met ons op.');
    }
  };

  const interceptPickupCheckout = (event, target) => {
    if (!target?.matches?.('#checkout, #CartDrawer-Checkout')) return false;
    if (getFulfillmentState().method !== 'pickup') return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    void beginPickupCheckout(target);
    return true;
  };

  document.addEventListener('change', (event) => {
    if (blockCartQuantityAboveConfirmedStock(event)) return;
    if (event.target.matches?.('.rale-widget input[type="checkbox"], bike-order-consent input[type="checkbox"]')) {
      syncCheckoutAvailability();
      return;
    }
    const fulfillmentInput = event.target.closest?.('.cart-fulfillment-option__input');
    if (fulfillmentInput) {
      void persistFulfillmentMethod(fulfillmentInput.value);
      return;
    }
    const input = event.target.closest?.('.cart-delivery-option__input');
    if (!input) return;
    persistDeliveryStrategy(input.value);
  }, true);

  document.addEventListener('input', (event) => {
    const form = event.target?.form;
    if (formQuantityGuard(form)) clearProductQuantityError(form);
  });

  document.addEventListener('click', (event) => {
    if (window.twoWsBikeOrderConsent?.block(event)) return;
    if (blockCheckoutWithoutTerms(event)) return;
    const target = checkoutTarget(event.target);
    if (interceptPickupCheckout(event, target)) return;
    activateBadgeToggle(event);
  }, true);

  document.addEventListener('submit', (event) => {
    if (window.twoWsBikeOrderConsent?.block(event)) return;
    if (blockProductQuantityAboveConfirmedStock(event)) return;
    const submitter = event.submitter || event.target.querySelector?.('#checkout, #CartDrawer-Checkout');
    const target = checkoutTarget(submitter);
    if (!target) return;
    if (!termsAreAccepted(target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showTermsError(target);
      syncCheckoutAvailability();
      return;
    }
    interceptPickupCheckout(event, target);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!['Enter', ' '].includes(event.key)) return;
    activateBadgeToggle(event);
  });

  mobileBadgeMedia.addEventListener('change', setupBadgeToggles);

  const scheduleCartPromiseSync = () => window.setTimeout(() => {
    const { strategy } = getDeliveryState();
    setDeliveryControlsState({ strategy });
    const records = getCartPromiseRecords();
    syncCartQuantityLimits(records);
    syncCurrentCartPromises();
    syncCheckoutAvailability();
  }, 0);

  scheduleCartPromiseSync();
  scheduleSmallOrderFeeSync();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCartPromiseSync);
    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source } = {}) => {
      if (source !== 'small-order-fee') scheduleSmallOrderFeeSync();
    });
  }

  new MutationObserver((mutations) => {
    const hasPromiseContent = mutations.some((mutation) => [...mutation.addedNodes].some((node) =>
      node.nodeType === 1 && (
        node.matches?.('script[data-cart-order-promise], [data-cart-delivery-controller]')
        || node.querySelector?.('script[data-cart-order-promise], [data-cart-delivery-controller]')
      )
    ));
    if (hasPromiseContent) scheduleCartPromiseSync();
    const hasOrderSummaryChange = mutations.some((mutation) => {
      const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      return Boolean(target?.closest?.('[data-cart-order-summary]'));
    });
    if (hasOrderSummaryChange) window.setTimeout(() => {
      updateCartOrderSummary(getDeliveryState().strategy);
    }, 0);
    const hasCheckoutOrTermsChange = mutations.some((mutation) => [...mutation.addedNodes].some((node) =>
      node.nodeType === 1 && (
        node.matches?.('.rale-widget, #checkout, #CartDrawer-Checkout, .additional-checkout-buttons')
        || node.querySelector?.('.rale-widget, #checkout, #CartDrawer-Checkout, .additional-checkout-buttons')
      )
    ));
    if (hasCheckoutOrTermsChange) window.setTimeout(syncCheckoutAvailability, 0);
  }).observe(document.documentElement, { childList: true, subtree: true });
}
